import Vue from 'vue';
import VueGoogleMaps from 'vue-googlemaps';

Vue.use(VueGoogleMaps, {
    load: {
      // your Google API key
      apiKey: 'AIzaSyAnG0poz0C20gFsCmNfqKGrYREEoopBP7A',
    },
  });